
const ENGLISH_SYSTEM_MESSAGES = new Set([
  "internal server error",
  "bad request",
  "unauthorized",
  "forbidden",
  "not found",
  "conflict",
  "service unavailable",
  "request timeout",
  "unprocessable entity",
  "payload too large",
]);

const ENGLISH_TOKENS =
  /\b(must be|must not|should not|is required|does not|cannot be|failed with status|is not)\b/i;

function looksLikeEnglishSystem(message: string): boolean {
  const normalized = message.trim().toLowerCase();
  if (ENGLISH_SYSTEM_MESSAGES.has(normalized)) return true;
  return ENGLISH_TOKENS.test(normalized);
}

const STATUS_MESSAGES: Record<number, string> = {
  400: "Requisição inválida. Confira os dados e tente novamente.",
  401: "Sua sessão expirou. Faça login novamente.",
  403: "Você não tem permissão para realizar esta ação.",
  404: "Registro não encontrado.",
  409: "Este registro conflita com outro já existente.",
  413: "Arquivo grande demais para o envio.",
  422: "Não foi possível processar os dados enviados.",
  500: "Erro interno no servidor. Tente novamente em instantes.",
  502: "Servidor indisponível. Tente novamente em instantes.",
  503: "Serviço temporariamente indisponível. Tente novamente.",
  504: "O servidor demorou a responder. Tente novamente.",
};

const TRANSPORT_MESSAGES: Record<string, string> = {
  FETCH_ERROR: "Falha de conexão. Verifique sua internet e tente novamente.",
  TIMEOUT_ERROR: "O servidor demorou a responder. Tente novamente.",
  PARSE_ERROR: "Resposta inesperada do servidor. Tente novamente.",
};

function extractRawMessage(error: unknown): string | null {
  if (!error || typeof error !== "object") return null;
  const data = (error as { data?: unknown }).data;
  if (!data || typeof data !== "object") return null;

  const messages = (data as { messages?: unknown }).messages;
  if (Array.isArray(messages) && typeof messages[0] === "string") {
    return messages[0];
  }
  const message = (data as { message?: unknown }).message;
  if (typeof message === "string") return message;
  return null;
}

function extractStatus(error: unknown): number | string | null {
  if (!error || typeof error !== "object") return null;
  const status = (error as { status?: unknown }).status;
  if (typeof status === "number" || typeof status === "string") return status;
  return null;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const raw = extractRawMessage(error);
  if (raw && raw.trim() && !looksLikeEnglishSystem(raw)) {
    return raw.trim();
  }

  const status = extractStatus(error);
  if (typeof status === "number" && STATUS_MESSAGES[status]) {
    return STATUS_MESSAGES[status];
  }
  if (typeof status === "string" && TRANSPORT_MESSAGES[status]) {
    return TRANSPORT_MESSAGES[status];
  }

  return fallback;
}
